import React from "react";
import PageHeader from "../components/PageHeader";
import Features from "../components/Features";

const Feature = () => {
  return (
    <>
      <PageHeader title="Feature" />
      <Features />
    </>
  );
};

export default Feature;
